import React from "react";
import EndpointListPageContainer from "./EndpointListPageContainer";

export class EndpointListPage extends React.Component {
  render() {
    return <EndpointListPageContainer {...this.props} />;
  }
}
